import { AppleAuthButton, SeparatorWithText } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

const SocialSignUp = (
  {
    disabled,
    onSubmitDisabled = () => {
      // do nothing
    },
  } = {
    disabled: false,
    onSubmitDisabled: () => {
      // do nothing
    },
  }
) => {
  const { t } = useTranslation()

  return (
    <>
      <SeparatorWithText text={t("Generic.or")} />

      <AppleAuthButton
        onSubmitDisabled={onSubmitDisabled}
        disabled={disabled}
        authType={"register"}
      />
    </>
  )
}

export default SocialSignUp
